import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CartFunnelOnBehalfUserFullNameItemBlockConfig } from '@front-platform/content-builder';
import { cartFunnelOnBehalfUserFullNameItemBlockResolveConfig } from '@front-platform/content-builder';
import { take } from 'rxjs/operators';
import { Component, OnInit, input } from '@angular/core';
import { DoodCartFunnelValueTarget } from '@store/cart-funnel';

import { CartFunnelStoreSelector } from '@common/selectors/cart-funnel.selector';
import { CartFunnelStoreDispatcher } from '@common/dispatchers/cart-funnel.dispatcher';
export interface CartFunnelOnBehalfUserFullNameItemBlockRuntimeConfig {
  'block_id'?: string;
  'form_id'?: string;
}

export type CartFunnelOnBehalfUserFullNameItemBlockConfigInput = Partial<
  CartFunnelOnBehalfUserFullNameItemBlockConfig &
    CartFunnelOnBehalfUserFullNameItemBlockRuntimeConfig
>;
export type CartFunnelOnBehalfUserFullNameItemBlockResolvedConfig = Omit<
  CartFunnelOnBehalfUserFullNameItemBlockConfig,
  keyof CartFunnelOnBehalfUserFullNameItemBlockRuntimeConfig
> &
  Partial<CartFunnelOnBehalfUserFullNameItemBlockRuntimeConfig>;
export interface CartFunnelOnBehalfUserFullNameItemBlockContract extends ConfigComponentContract<
  CartFunnelOnBehalfUserFullNameItemBlockConfigInput,
  CartFunnelOnBehalfUserFullNameItemBlockResolvedConfig
> {}

@Component({
  selector: 'app-cart-funnel-on-behalf-user-full-name-item-block',
  templateUrl: './cart-funnel-on-behalf-user-full-name-item-block.component.html',
  standalone: false,
})
export class CartFunnelOnBehalfUserFullNameItemBlockComponent
  implements OnInit, CartFunnelOnBehalfUserFullNameItemBlockContract
{
  readonly config = input<CartFunnelOnBehalfUserFullNameItemBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CartFunnelOnBehalfUserFullNameItemBlockConfig,
    CartFunnelOnBehalfUserFullNameItemBlockRuntimeConfig
  >(cartFunnelOnBehalfUserFullNameItemBlockResolveConfig, () => ({ config: this.config() }));
  get title(): string {
    return this.resolvedConfig()['title'] as unknown as string;
  }
  get placeholder(): string {
    return this.resolvedConfig()['placeholder'] as unknown as string;
  }
  get required(): boolean {
    return this.resolvedConfig()['required'] as unknown as boolean;
  }
  get blockId(): string {
    return this.resolvedConfig()['block_id'] as unknown as string;
  }
  get formId(): string {
    return this.resolvedConfig()['form_id'] as unknown as string;
  }

  value: string = '';

  constructor(
    private cartFunnelSelector: CartFunnelStoreSelector,
    private cartFunnelDispatcher: CartFunnelStoreDispatcher,
  ) {}

  ngOnInit(): void {
    this.cartFunnelDispatcher.addValue({
      id: this.blockId,
      title: this.title,
      displayTitle: true,
      formId: this.formId,
      required: this.required,
      target: DoodCartFunnelValueTarget.OnBehalfUserFullName,
    });

    this.cartFunnelSelector
      .selectValue(this.blockId)
      .pipe(take(1))
      .subscribe(form => {
        this.value = form?.value?.toString() ?? '';
      });
  }

  onValueChange(_value: string | boolean): void {
    this.cartFunnelDispatcher.updateValue({
      id: this.blockId,
      changes: {
        value: _value,
      },
    });
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CartFunnelOnBehalfUserFullNameItemBlockComponent, {
  'keyAliases': {},
});
